import { BOOKINGS_WIDGET_RECEIVE } from '../action-types';

export const fetchWidgets = (clubId) => async (dispatch) => {
  try {
    const { makeIsomorphicApiRequest } = await import('../../lib/api-proxy');

    const response = await makeIsomorphicApiRequest(`v2/facilities/${clubId}/widgets`);
    const widgetsData = await response.json();

    dispatch({ type: BOOKINGS_WIDGET_RECEIVE, payload: { widgetsData } });

    return {};
  } catch (error) {
    return { error };
  }
};
